import {arrayMove} from '@dnd-kit/sortable';

import {isNil, without} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * New preset order after dropping `activeId` onto `overId`.
 *
 * A collapsed row can show the selected (`pinnedId`) preset out of its stored place, pulled into
 * the last visible slot. When the drag involves that preset, the order is computed as displayed,
 * so the saved order matches the drop preview; presets not on screen keep their stored order
 * behind the displayed ones. Any other drag moves by the stored order, so the selected preset is
 * not saved at a position the user never gave it - and the collapsed row still looks the same.
 *
 * Returns `null` when nothing moves.
 */
export function getReorderedPresetIds(
  displayedIds: string[],
  storedIds: string[],
  activeId: string,
  overId: string | Nullish,
  pinnedId: string | Nullish
) {
  if (isNil(overId) || activeId === overId) {
    return null;
  }

  const isPinnedMoved = pinnedId === activeId || pinnedId === overId;
  const baseIds = isPinnedMoved
    ? [...displayedIds, ...without(displayedIds, storedIds)]
    : storedIds;
  const oldIndex = baseIds.indexOf(activeId);
  const newIndex = baseIds.indexOf(overId);

  if (oldIndex === -1 || newIndex === -1) {
    return null;
  }

  return arrayMove(baseIds, oldIndex, newIndex);
}
